<template>
  <div>
    <!-- <ContactFloatingBtn /> -->
    <!-- <Header /> -->
    <div class="hero about">
      <div class="inner">
        <h1>{{$t('aboutPage.text1')}}</h1>
        <h5 class="subtitle" v-html="$t('aboutPage.text2')"></h5>
      </div>
    </div>
    <section class="about-section1">
      <div class="section-inner">
        <ul class="about-list">
          <li>
            <img src="@/assets/icons/about-icon1.svg" alt="" />
            <div>
              <h3 class="list-title">{{$t('aboutPage.text3')}}</h3>
              <p>{{$t('aboutPage.text4')}}</p>
            </div>
          </li>
          <li>
            <img src="@/assets/icons/about-icon2.svg" alt="" />
            <div class="short">
              <h3 class="list-title">{{$t('aboutPage.text5')}}</h3>
              <p>{{$t('aboutPage.text6')}}</p>
            </div>
          </li>
          <li>
            <img src="@/assets/icons/about-icon3.svg" alt="" />
            <div>
              <h3 class="list-title">{{$t('aboutPage.text7')}}</h3>
              <div class="tap">
                <span>T</span>rading
                <span>A</span>s
                <span>P</span>lan
              </div>
              <p class="variant">{{$t('aboutPage.text8')}}</p>
            </div>
          </li>
          <li>
            <img src="@/assets/icons/about-icon4.svg" alt="" />
            <div>
              <h3 class="list-title">{{$t('aboutPage.text9')}}</h3>
              <div class="tap">
                <span>A</span>ny Time<span class="div-line">|</span>
                <span>A</span>ny Where<span class="div-line">|</span> <br>
                <span>A</span>ny Device<span class="div-line">|</span>
                <span>A</span>ny Level
              </div>
              <p class="variant">{{$t('aboutPage.text10')}}</p>
              <img class="about-img" src="@/assets/images/about-img1.png" alt="" />
            </div>
          </li>
        </ul>
      </div>
    </section>
		<section class="about-section2">
			<div class="section-inner small">
				<div class="about-col">
					<h2 class="number">
						2021
					</h2>
					<p>started in Fintech</p>
				</div>
				<div class="about-col">
					<h2 class="number">
						9
					</h2>
					<p>developed financial <br>
							applications</p>
				</div>
				<div class="about-col">
					<h2 class="number">
						6
					</h2>
					<p>of the world’s best financial <br>
software development engineers</p>
				</div>
				<div class="about-col">
					<h2 class="number">
						17
					</h2>
					<p>securities use Delkoit <br>
technology daily</p>
				</div>
			</div>
		</section>
		<section class="about-section3">
			<div class="section-inner">
				<h2 class="section-title">Our Certification</h2>
				<div class="certification">
					<img src="@/assets/images/cert1.png" alt="">
					<img src="@/assets/images/cert2.png" alt="">
					<img src="@/assets/images/cert3.png" alt="">
					<img src="@/assets/images/cert4.png" alt="">
          <img src="@/assets/images/cert5.png" alt="">
          <img src="@/assets/images/cert6.png" alt="">
				</div>
			</div>
		</section>
    <!-- <Footer /> -->
  </div>
</template>

<script>
// import ContactFloatingBtn from '../components/ContactFloatingBtn.vue';
// import Footer from '@/components/Footer.vue'
// import Header from  '@/components/Header.vue'
export default {
  name: 'AboutPage',
  components: {
    // ContactFloatingBtn
    // Header,
    // Footer
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
